module.exports = __webpack_public_path__ + "img/icon_submenu8dark.8fce7ea7.svg";